import { BaseModel } from '@tcc-mono/shared/data-access';

export class BookingItem extends BaseModel {
  id: number;
  name: string;
  gl_account: string;
  created_at?: string;
  updated_at?: string;

  public constructor(bookingItem?: Partial<BookingItem>) {
    super();
    this.id = bookingItem?.id;
    this.name = bookingItem?.name || '';
    this.gl_account = bookingItem?.gl_account || '';
    this.created_at = bookingItem?.created_at;
    this.updated_at = bookingItem?.updated_at;
  }
}
